/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateGeneralCargoAreaDto } from '../model';
// @ts-ignore
import type { GeneralCargoAreaDto } from '../model';
// @ts-ignore
import type { GeneralCargoLocationDto } from '../model';
// @ts-ignore
import type { UpdateGeneralCargoAreaDto } from '../model';
/**
 * GeneralCargoAreasApi - axios parameter creator
 */
export const GeneralCargoAreasApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateGeneralCargoAreaDto} [createGeneralCargoAreaDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoAreasCreate: async (createGeneralCargoAreaDto?: CreateGeneralCargoAreaDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoAreas/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGeneralCargoAreaDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [generalCargoAreaId] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoAreasCreateLocation: async (generalCargoAreaId?: string, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoAreas/CreateLocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (generalCargoAreaId !== undefined) {
                localVarQueryParameter['generalCargoAreaId'] = generalCargoAreaId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoAreasDelete: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoAreas/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoAreasDeleteLocation: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoAreas/DeleteLocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoAreasGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('generalCargoAreasGet', 'id', id)
            const localVarPath = `/storage/api/GeneralCargoAreas/Get/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoAreasGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoAreas/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoAreasIsNameUnique: async (name?: string, id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoAreas/IsNameUnique`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateGeneralCargoAreaDto} [updateGeneralCargoAreaDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoAreasUpdate: async (id: string, updateGeneralCargoAreaDto?: UpdateGeneralCargoAreaDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('generalCargoAreasUpdate', 'id', id)
            const localVarPath = `/storage/api/GeneralCargoAreas/Update/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGeneralCargoAreaDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoAreasUpdateLocation: async (id?: string, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/GeneralCargoAreas/UpdateLocation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GeneralCargoAreasApi - functional programming interface
 */
export const GeneralCargoAreasApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GeneralCargoAreasApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateGeneralCargoAreaDto} [createGeneralCargoAreaDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoAreasCreate(createGeneralCargoAreaDto?: CreateGeneralCargoAreaDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralCargoAreaDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoAreasCreate(createGeneralCargoAreaDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoAreasApi.generalCargoAreasCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [generalCargoAreaId] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoAreasCreateLocation(generalCargoAreaId?: string, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralCargoLocationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoAreasCreateLocation(generalCargoAreaId, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoAreasApi.generalCargoAreasCreateLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoAreasDelete(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoAreasDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoAreasApi.generalCargoAreasDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoAreasDeleteLocation(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoAreasDeleteLocation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoAreasApi.generalCargoAreasDeleteLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoAreasGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneralCargoAreaDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoAreasGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoAreasApi.generalCargoAreasGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoAreasGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeneralCargoAreaDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoAreasGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoAreasApi.generalCargoAreasGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [name] 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoAreasIsNameUnique(name?: string, id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoAreasIsNameUnique(name, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoAreasApi.generalCargoAreasIsNameUnique']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateGeneralCargoAreaDto} [updateGeneralCargoAreaDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoAreasUpdate(id: string, updateGeneralCargoAreaDto?: UpdateGeneralCargoAreaDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoAreasUpdate(id, updateGeneralCargoAreaDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoAreasApi.generalCargoAreasUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generalCargoAreasUpdateLocation(id?: string, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generalCargoAreasUpdateLocation(id, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GeneralCargoAreasApi.generalCargoAreasUpdateLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GeneralCargoAreasApi - factory interface
 */
export const GeneralCargoAreasApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GeneralCargoAreasApiFp(configuration)
    return {
        /**
         * 
         * @param {GeneralCargoAreasApiGeneralCargoAreasCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoAreasCreate(requestParameters: GeneralCargoAreasApiGeneralCargoAreasCreateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GeneralCargoAreaDto> {
            return localVarFp.generalCargoAreasCreate(requestParameters.createGeneralCargoAreaDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralCargoAreasApiGeneralCargoAreasCreateLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoAreasCreateLocation(requestParameters: GeneralCargoAreasApiGeneralCargoAreasCreateLocationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GeneralCargoLocationDto> {
            return localVarFp.generalCargoAreasCreateLocation(requestParameters.generalCargoAreaId, requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralCargoAreasApiGeneralCargoAreasDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoAreasDelete(requestParameters: GeneralCargoAreasApiGeneralCargoAreasDeleteRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generalCargoAreasDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralCargoAreasApiGeneralCargoAreasDeleteLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoAreasDeleteLocation(requestParameters: GeneralCargoAreasApiGeneralCargoAreasDeleteLocationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generalCargoAreasDeleteLocation(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralCargoAreasApiGeneralCargoAreasGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoAreasGet(requestParameters: GeneralCargoAreasApiGeneralCargoAreasGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<GeneralCargoAreaDto> {
            return localVarFp.generalCargoAreasGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoAreasGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<GeneralCargoAreaDto>> {
            return localVarFp.generalCargoAreasGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralCargoAreasApiGeneralCargoAreasIsNameUniqueRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoAreasIsNameUnique(requestParameters: GeneralCargoAreasApiGeneralCargoAreasIsNameUniqueRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.generalCargoAreasIsNameUnique(requestParameters.name, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralCargoAreasApiGeneralCargoAreasUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoAreasUpdate(requestParameters: GeneralCargoAreasApiGeneralCargoAreasUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generalCargoAreasUpdate(requestParameters.id, requestParameters.updateGeneralCargoAreaDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GeneralCargoAreasApiGeneralCargoAreasUpdateLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generalCargoAreasUpdateLocation(requestParameters: GeneralCargoAreasApiGeneralCargoAreasUpdateLocationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.generalCargoAreasUpdateLocation(requestParameters.id, requestParameters.name, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for generalCargoAreasCreate operation in GeneralCargoAreasApi.
 */
export interface GeneralCargoAreasApiGeneralCargoAreasCreateRequest {
    readonly createGeneralCargoAreaDto?: CreateGeneralCargoAreaDto
}

/**
 * Request parameters for generalCargoAreasCreateLocation operation in GeneralCargoAreasApi.
 */
export interface GeneralCargoAreasApiGeneralCargoAreasCreateLocationRequest {
    readonly generalCargoAreaId?: string

    readonly name?: string
}

/**
 * Request parameters for generalCargoAreasDelete operation in GeneralCargoAreasApi.
 */
export interface GeneralCargoAreasApiGeneralCargoAreasDeleteRequest {
    readonly id?: string
}

/**
 * Request parameters for generalCargoAreasDeleteLocation operation in GeneralCargoAreasApi.
 */
export interface GeneralCargoAreasApiGeneralCargoAreasDeleteLocationRequest {
    readonly id?: string
}

/**
 * Request parameters for generalCargoAreasGet operation in GeneralCargoAreasApi.
 */
export interface GeneralCargoAreasApiGeneralCargoAreasGetRequest {
    readonly id: string
}

/**
 * Request parameters for generalCargoAreasIsNameUnique operation in GeneralCargoAreasApi.
 */
export interface GeneralCargoAreasApiGeneralCargoAreasIsNameUniqueRequest {
    readonly name?: string

    readonly id?: string
}

/**
 * Request parameters for generalCargoAreasUpdate operation in GeneralCargoAreasApi.
 */
export interface GeneralCargoAreasApiGeneralCargoAreasUpdateRequest {
    readonly id: string

    readonly updateGeneralCargoAreaDto?: UpdateGeneralCargoAreaDto
}

/**
 * Request parameters for generalCargoAreasUpdateLocation operation in GeneralCargoAreasApi.
 */
export interface GeneralCargoAreasApiGeneralCargoAreasUpdateLocationRequest {
    readonly id?: string

    readonly name?: string
}

/**
 * GeneralCargoAreasApi - object-oriented interface
 */
export class GeneralCargoAreasApi extends BaseAPI {
    /**
     * 
     * @param {GeneralCargoAreasApiGeneralCargoAreasCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoAreasCreate(requestParameters: GeneralCargoAreasApiGeneralCargoAreasCreateRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralCargoAreasApiFp(this.configuration).generalCargoAreasCreate(requestParameters.createGeneralCargoAreaDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralCargoAreasApiGeneralCargoAreasCreateLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoAreasCreateLocation(requestParameters: GeneralCargoAreasApiGeneralCargoAreasCreateLocationRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralCargoAreasApiFp(this.configuration).generalCargoAreasCreateLocation(requestParameters.generalCargoAreaId, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralCargoAreasApiGeneralCargoAreasDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoAreasDelete(requestParameters: GeneralCargoAreasApiGeneralCargoAreasDeleteRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralCargoAreasApiFp(this.configuration).generalCargoAreasDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralCargoAreasApiGeneralCargoAreasDeleteLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoAreasDeleteLocation(requestParameters: GeneralCargoAreasApiGeneralCargoAreasDeleteLocationRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralCargoAreasApiFp(this.configuration).generalCargoAreasDeleteLocation(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralCargoAreasApiGeneralCargoAreasGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoAreasGet(requestParameters: GeneralCargoAreasApiGeneralCargoAreasGetRequest, options?: RawAxiosRequestConfig) {
        return GeneralCargoAreasApiFp(this.configuration).generalCargoAreasGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoAreasGetAll(options?: RawAxiosRequestConfig) {
        return GeneralCargoAreasApiFp(this.configuration).generalCargoAreasGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralCargoAreasApiGeneralCargoAreasIsNameUniqueRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoAreasIsNameUnique(requestParameters: GeneralCargoAreasApiGeneralCargoAreasIsNameUniqueRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralCargoAreasApiFp(this.configuration).generalCargoAreasIsNameUnique(requestParameters.name, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralCargoAreasApiGeneralCargoAreasUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoAreasUpdate(requestParameters: GeneralCargoAreasApiGeneralCargoAreasUpdateRequest, options?: RawAxiosRequestConfig) {
        return GeneralCargoAreasApiFp(this.configuration).generalCargoAreasUpdate(requestParameters.id, requestParameters.updateGeneralCargoAreaDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GeneralCargoAreasApiGeneralCargoAreasUpdateLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public generalCargoAreasUpdateLocation(requestParameters: GeneralCargoAreasApiGeneralCargoAreasUpdateLocationRequest = {}, options?: RawAxiosRequestConfig) {
        return GeneralCargoAreasApiFp(this.configuration).generalCargoAreasUpdateLocation(requestParameters.id, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }
}

